// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BillItem\ApiBillItem.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Bill, BillData, BillOptions } from 'data/models/Bill';
import { Measurement, MeasurementData, MeasurementOptions } from 'data/models/Measurement';
import { Price, PriceData, PriceOptions } from 'data/models/Price';
import { QuickBooksInventoryItemTracking, QuickBooksInventoryItemTrackingData, QuickBooksInventoryItemTrackingOptions } from 'data/models/QuickBooksInventoryItemTracking';
import { Rate, RateData, RateOptions } from 'data/models/Rate';
import { StandardItem, StandardItemData, StandardItemOptions } from 'data/models/StandardItem';

// BillItemData is the class that BillItem serializes to/from
export interface BillItemData {
    Id : number;
	
    Bill : BillData | null;
    BillId : number;
    StandardItem : StandardItemData | null;
    StandardItemId : number | null;
    StandardRate : RateData | null;
    StandardRateId : number | null;
	
    Description : string | null;
    Guid : /* GUID */ string;
    QBTrackingOverrides : QuickBooksInventoryItemTrackingData;
    Quantity : MeasurementData;
    Total : PriceData;
    Unit : MeasurementData;
    UnitPrice : PriceData;
}

// BillItemOptions is the class which may be passed to the BillItem constructor to define optional initial data values
export interface BillItemOptions {
    Id : number;
	
    Bill? : BillOptions | null;
    BillId? : number;
    StandardItem? : StandardItemOptions | null;
    StandardItemId? : number | null;
    StandardRate? : RateOptions | null;
    StandardRateId? : number | null;
	
    Description? : string | null;
    Guid? : /* GUID */ string;
    QBTrackingOverrides? : QuickBooksInventoryItemTrackingOptions;
    Quantity? : MeasurementOptions;
    Unit? : MeasurementOptions;
    UnitPrice? : PriceOptions;
}

export class BillItem {
    public Id : DataSignal<number>;
	
    public Bill : DataSignal<Bill | null>;
    public BillId : DataSignal<number>;
    public StandardItem : DataSignal<StandardItem | null>;
    public StandardItemId : DataSignal<number | null>;
    public StandardRate : DataSignal<Rate | null>;
    public StandardRateId : DataSignal<number | null>;
	
    public Description : DataSignal<string | null>;
    public Guid : DataSignal<string>;
    public QBTrackingOverrides : QuickBooksInventoryItemTracking;
    public Quantity : Measurement;
    public Unit : Measurement;
    public UnitPrice : Price;

    constructor();
    constructor(data : BillItemOptions);
    constructor(data: BillItemOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Bill = S.value<Bill | null>(null);
        this.BillId = jsonableObservable(S.value<number>(data && data.BillId !== undefined ? data.BillId : 0));
        this.StandardItem = S.value<StandardItem | null>(null);
        this.StandardItemId = jsonableObservable(S.value<number | null>(data && data.StandardItemId !== undefined ? data.StandardItemId : null));
        this.StandardRate = S.value<Rate | null>(null);
        this.StandardRateId = jsonableObservable(S.value<number | null>(data && data.StandardRateId !== undefined ? data.StandardRateId : null));
	    
        this.Description = jsonableObservable(S.value<string | null>(data && data.Description !== undefined ? data.Description : null));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.QBTrackingOverrides = data && data.QBTrackingOverrides !== undefined ? new QuickBooksInventoryItemTracking(data.QBTrackingOverrides) : new QuickBooksInventoryItemTracking();
        this.Quantity = data && data.Quantity !== undefined ? new Measurement(data.Quantity) : new Measurement();
        this.Unit = data && data.Unit !== undefined ? new Measurement(data.Unit) : new Measurement();
        this.UnitPrice = data && data.UnitPrice !== undefined ? new Price(data.UnitPrice) : new Price();
    }

    static key(obj : BillItem) {
        return obj.Id();
    }
    
    static dataKey(obj : BillItemOptions) {
        return obj.Id;
    }

    static update(obj : BillItem, data : BillItemOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.BillId !== undefined) obj.BillId(data.BillId);
            if (data.StandardItemId !== undefined) obj.StandardItemId(data.StandardItemId);
            if (data.StandardRateId !== undefined) obj.StandardRateId(data.StandardRateId);
	        
            if (data.Description !== undefined) obj.Description(data.Description);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.QBTrackingOverrides !== undefined) QuickBooksInventoryItemTracking.update(obj.QBTrackingOverrides, data.QBTrackingOverrides);
            if (data.Quantity !== undefined) Measurement.update(obj.Quantity, data.Quantity);
            if (data.Unit !== undefined) Measurement.update(obj.Unit, data.Unit);
            if (data.UnitPrice !== undefined) Price.update(obj.UnitPrice, data.UnitPrice);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BillItem.ts